import { useState } from "react";
import { useAsync } from "react-async";
import { DashboardProps, DashboardPropsDefaults } from "../../types/dashboardProps.d";
import { getTherapistsByDirectorUserId } from '../../../../api/services/directorService';
import User from "../../../../api/models/user";
import Spinner from "../../../spinner";
import { Link } from "react-router-dom";

const fetchTherapistsByDirectorUserId = async ({ id }: any) => {
    return await getTherapistsByDirectorUserId(id);
}

const DashboardWidgetDirectorTherapists = ({ user }: DashboardProps): JSX.Element => {
    const [therapists, setTherapists] = useState<User[]>([]);
    const id: number = user.userId!;

    const asyncTherapists = useAsync({
        promiseFn: fetchTherapistsByDirectorUserId, id,
        onResolve: (r) => {
            const users: User[] = r.data.filter((value, index, self) =>
                index === self.findIndex((t) => (t.userId === value.userId)));
            setTherapists(users);
        }
    });

    return (
        <>
            <div className={`${DashboardPropsDefaults.containerClassNames} dashboard-widget-half`}>
                <div className="pb-1 dashboard-widget-title">
                    <h3>Therapists ({therapists.length})</h3>
                </div>
                <div className={`${DashboardPropsDefaults.contentClassNames}`}>
                    <Spinner show={asyncTherapists.isPending} />
                    {!asyncTherapists.isPending && (
                        <>
                            {therapists && therapists.length > 0 && (
                                <>
                                    {therapists.map((d: User) => (
                                        <p>
                                            <Link
                                                key={`therapist-widget-${d.userId}-${Math.random()}`}
                                                className={`mb-2 w-2/5 overflow-hidden`}
                                                to={`/admin/therapists/${d.userId}`}
                                            >{d.lastName}, {d.firstName}
                                            </Link>
                                        </p>
                                    ))}
                                </>
                            )}
                        </>
                    )}
                </div>
            </div>
        </>
    );
};

export default DashboardWidgetDirectorTherapists;
